import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccountState {
  password: string;
}

const initialState: AccountState = {
  password: '',
};

const account = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setPassword: (state, { payload }: PayloadAction<string>) => {
      state.password = payload;
    },
  },
});

export const { setPassword } = account.actions;

export default account.reducer;
